import type { ReactElement } from "react";
import { useMemo } from "react";

import { ConditionCard } from "app/pages/sales-intelligence/common-components/filters-panel";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { INDUSTRIES_CODE_NAMES, industryCodeDtoMap } from "app/pages/sales-intelligence/domain/industry/types/codes";
import type { IIndustryCodesFilterDto } from "app/pages/sales-intelligence/domain/industry/types/filter-values";

interface IInclusionIndustryCodesChipProps {
    item: IIndustryCodesFilterDto;
    hideActionButton?: boolean;
    onEdit: (item: IIndustryCodesFilterDto) => void;
    onDelete: (item: IIndustryCodesFilterDto) => void;
}

const InclusionIndustryCodesChip = ({
    item,
    hideActionButton = false,
    onEdit,
    onDelete,
}: IInclusionIndustryCodesChipProps): ReactElement => {
    const values = useMemo(
        (): string[] => [
            ...item.sicCodes.map((code) => `${INDUSTRIES_CODE_NAMES[industryCodeDtoMap.sic]}: ${code}`),
            ...item.naicsCodes.map((code) => `${INDUSTRIES_CODE_NAMES[industryCodeDtoMap.naics]}: ${code}`),
        ],
        [item],
    );

    return (
        <ConditionCard
            inclusionLabel={<I18n translatable={{ key: `si.common.inclusions.${item.inclusion}` }} />}
            values={values}
            hideActions={hideActionButton}
            onEdit={() => onEdit(item)}
            onDelete={() => onDelete(item)}
            dataAutomation="industry-codes-inclusion-chip"
        />
    );
};

export default InclusionIndustryCodesChip;
